var map = {
	"./LOGO-white.png": 6390,
	"./LOGO.png": 759,
	"./about-culture.png": 615,
	"./about-history.jpg": 1296,
	"./about-rekey1.jpg": 8971,
	"./about-rekey2.jpg": 112,
	"./aboutbanner.jpg": 3747,
	"./banner1.jpg": 7701,
	"./banner2.jpg": 8845,
	"./banner3.jpg": 7421,
	"./building-left.jpg": 8095,
	"./building-right.jpg": 850,
	"./code.jpg": 9210,
	"./code.png": 6259,
	"./contact-talent.jpg": 2559,
	"./contact.png": 8125,
	"./contactus-bg.png": 1165,
	"./cooperation_banner.jpg": 501,
	"./env1.png": 3186,
	"./env2.png": 6548,
	"./env3.png": 6004,
	"./formula.png": 20,
	"./home-about.jpg": 5149,
	"./home-product.png": 156,
	"./home-team.jpg": 6220,
	"./home-tech.jpg": 6611,
	"./honor1.jpg": 5255,
	"./honor2.jpg": 2898,
	"./honor3.jpg": 2083,
	"./honor4.jpg": 5536,
	"./honor5.jpg": 2261,
	"./honor6.jpg": 263,
	"./honorcombine.jpg": 8401,
	"./icon/cart-white.png": 8747,
	"./icon/cart.png": 7958,
	"./icon/formula.png": 8463,
	"./icon/iconfont.ttf": 3412,
	"./icon/return.png": 2723,
	"./icon/search.png": 9586,
	"./js/China": 8432,
	"./js/China.json": 8432,
	"./logocenter.png": 7663,
	"./logotext.png": 2346,
	"./logotrans.png": 3754,
	"./map.png": 3808,
	"./nerve_scaffold1.png": 1269,
	"./nerve_scaffold2.png": 7477,
	"./nerve_scaffold3.png": 9150,
	"./nodata.png": 5635,
	"./pattents.jpg": 1558,
	"./product-banner.jpg": 9838,
	"./team1.png": 5810,
	"./team2.png": 9215,
	"./text/SourceHanSansCN-Regular.ttf": 9722,
	"./text/font.css": 7885,
	"./titlelogo.png": 9849,
	"./wechat.png": 1157,
	"./white.png": 1477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;